/** @jsx h */
import { h } from 'preact'

import t from '../../../utils/translate'

const CollaboratorActivity = ({ description }) => {
  if (!description) {
    return null
  }

  return (
    <section class='ModalCard-section'>
      <h3 class='ModalCard-heading'>{t('proof_points.js.claims.what')}</h3>
      <p class='ModalCard-para u-marginTop8'>{description}</p>
    </section>
  )
}

export default CollaboratorActivity
